import type { ITenantDestination } from '@/shared/api/types/tenant-destination-types'
import type { ITenant, TenantDto } from '@/shared/api/types/tenant-types'

export function mapTenantDto(dto: TenantDto): ITenant {
  return {
    id: dto.id,
    name: dto.name,
    slug: dto.slug,
    description: dto.description ?? '',
    logoUrl: dto.logoUrl ?? '',
    website: dto.website ?? '',
    contactEmail: dto.contactEmail ?? '',
    isActive: dto.isActive,
    createdAt: dto.createdAt ?? '',
    updatedAt: dto.updatedAt ?? '',
    defaultLanguage: dto.defaultLanguage ?? null,
    localizedData: dto.localizedData ?? {},
    phone: dto.contactPhone ?? '',
  }
}

export interface TenantDestinationDTO {
  id: string
  tenantId: string
  destinationId?: string | null
  countryId?: string | null
  provinceId?: string | null
  banner?: string | null
  thumbnail?: string | null
  fallback?: ITenantDestination['fallback']
  isDeleted: boolean
  isActive?: boolean
  localizedData?: ITenantDestination['localizedData']
  centerLat?: string | number | null
  centerLng?: string | number | null
  areaBoundary?: ITenantDestination['areaBoundary']
  createdAt: string
  updatedAt: string
}

function toNumberOrNull(value: string | number | null | undefined): number | null {
  if (value === null || value === undefined) {
    return null
  }
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null
  }
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : null
}

export function mapTenantDestinationDto(dto: TenantDestinationDTO): ITenantDestination {
  return {
    id: dto.id,
    tenantId: dto.tenantId,
    ...(dto.destinationId !== undefined ? { destinationId: dto.destinationId } : {}),
    ...(dto.countryId !== undefined ? { countryId: dto.countryId } : {}),
    ...(dto.provinceId !== undefined ? { provinceId: dto.provinceId } : {}),
    ...(dto.banner !== undefined ? { banner: dto.banner } : {}),
    ...(dto.thumbnail !== undefined ? { thumbnail: dto.thumbnail } : {}),
    ...(dto.fallback !== undefined ? { fallback: dto.fallback ?? null } : {}),
    isDeleted: dto.isDeleted,
    isActive: dto.isActive ?? !dto.isDeleted,
    ...(dto.localizedData !== undefined ? { localizedData: dto.localizedData } : {}),
    centerLat: toNumberOrNull(dto.centerLat),
    centerLng: toNumberOrNull(dto.centerLng),
    ...(dto.areaBoundary !== undefined ? { areaBoundary: dto.areaBoundary } : {}),
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  }
}
